import React, { useMemo } from 'react'
import { usePartnerSettings } from '@@partner:helpers/hooks/auth'

import ProductSearchItem from './ProductSearchItem'
import ProductSearchCard from './ProductSearchCard'

import { UI_SETTING_IS_OLD_ORDER_FORM_CART_MODE } from '@@partner:config/ui-settings'

export default function ProductSearchItemWidget (props: any) {
  const { getSetting } = usePartnerSettings()
  const CardComponent = useMemo(
    () =>
      getSetting(UI_SETTING_IS_OLD_ORDER_FORM_CART_MODE, false)
        ? ProductSearchItem
        : ProductSearchCard,
    [ getSetting ]
  )

  return <CardComponent {...props} />
}
